import styled from "styled-components";
import { colors } from "../../../../../../../theme/theme";

export const OrderPeriodFilterWrapper = styled.div`
	display: flex;
	align-items: center;
	gap: 8px;
	margin: 24px 0;
	color: ${colors.greyscale.black};

	.p-dropdown {
		height: 32px;
		line-height: 1;
		width: 240px;
	}

	.p-dropdown-label {
		padding: 8px 16px;
	}
`;
